import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=4815d318"
import script from "./task-list.vue?vue&type=script&lang=js"
export * from "./task-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports